import { jsx } from '@emotion/react/jsx-runtime';
import { Global } from '@emotion/react';
import { useCssMixins } from './use-css-mixins.js';

/**
 * Global styles applying base styles and reset CSS to normalize browser inconsistencies.
 */ const GlobalStyles = ({ background = 'neutral' })=>{
    const mixins = useCssMixins();
    return /*#__PURE__*/ jsx(Global, {
        styles: (theme)=>({
                html: {
                    // Include padding and border when using width or height by default.
                    boxSizing: 'border-box',
                    // Normalize the line height in all browsers.
                    lineHeight: 1,
                    // Prevent adjustments of font size after orientation changes in iOS.
                    textSizeAdjust: '100%',
                    // https://github.com/adobe/react-spectrum/issues/8086#issuecomment-2822138500
                    touchAction: 'pan-x pan-y pinch-zoom'
                },
                // Inherit border-box from the html selector above for all elements, but allow for individual overriding.
                '*, *::before, *::after': {
                    boxSizing: 'inherit'
                },
                // Remove the hideous highlight on click for iOS devices.
                '*': {
                    WebkitTapHighlightColor: 'transparent'
                },
                // Remove the gruesome default focus indicator.
                '*:focus': {
                    outline: 'none'
                },
                // Remove the margin for the body and all heading elements.
                'body, h1, h2, h3, h4, h5, h6': {
                    margin: 0
                },
                // Apply default typography styles.
                body: [
                    mixins.typography({
                        color: 'gray',
                        colorTone: 'medium',
                        ...theme.aliases.typography.body
                    }),
                    background && mixins.background(background)
                ],
                // Apply default heading styles.
                h1: mixins.typography(theme.aliases.typography.heading[1]),
                h2: mixins.typography(theme.aliases.typography.heading[2]),
                h3: mixins.typography(theme.aliases.typography.heading[3]),
                h4: mixins.typography(theme.aliases.typography.heading[4]),
                h5: mixins.typography(theme.aliases.typography.heading[5]),
                h6: mixins.typography(theme.aliases.typography.heading[6]),
                // Make sure all elements inherits the default typography styles.
                'button, input, optgroup, select, textarea': {
                    fontFamily: 'inherit',
                    fontSize: '100%',
                    minWidth: 0,
                    padding: 0
                },
                // Remove default styles for all fieldset and legend elements.
                fieldset: {
                    border: 0,
                    padding: 0,
                    margin: 0,
                    minWidth: 0
                },
                legend: {
                    padding: 0
                },
                // Remove default styles for all table elements.
                'table, caption, tbody, tfoot, thead, tr, th, td': {
                    margin: 0,
                    padding: 0,
                    border: 0,
                    fontSize: '100%',
                    font: 'inherit'
                },
                table: {
                    borderCollapse: 'collapse',
                    borderSpacing: 0
                },
                // Remove the default styling of anchor elements. Use a `Link` component for styled links.
                a: {
                    textDecoration: 'none',
                    color: 'inherit'
                },
                // Remove the default styling of button elements.
                button: {
                    background: 'transparent',
                    border: 'none',
                    color: 'inherit',
                    cursor: 'pointer',
                    padding: 0
                }
            })
    });
};

export { GlobalStyles };
//# sourceMappingURL=global-styles.js.map
